
<template>
  <v-container fill-height fluid>
    <v-row justify="center" align="center">
      <v-col md="6" lg="4" xl="4" xs="12" sm="10">
        <v-card elevation="14" color="#e8e4e4" id="uploaderCard" class="rounded-lg">
          <v-row justify="center" align="center">
            <v-card-title class="card-title">
              upload anime image
            </v-card-title>
          </v-row>
          <v-form action="/api/anime/resize" method="POST"
                  enctype="multipart/form-data" target="_blank">
            <v-file-input accept="image/jpeg"
                  id="file" name="file" show-size label="Browse from device"
                  prepend-icon="mdi-camera" class="image-uploader"
                  @change="checkFileAdded" multiple="false"/>
            <v-alert type="error" v-if="showValidationAlert">
              Image should be less than 2 MB and JPEG file is a mandatory type
            </v-alert>
            <v-alert type="error" v-if="serverErrorFlag">
              {{serverErrorMessage}}
            </v-alert>
            <div class="upload-button">
              <div v-if="!uploadInProgress">
                <v-btn v-if="!uploadInProgress"
                     @click="uploadFile()"
                       v-bind:disabled="!fileAdded">Upload
                </v-btn>
              </div>
              <div v-else>
                <v-icon>fas fa-circle-notch fa-spin</v-icon>
              </div>
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {post, get} from "axios";

export default {
  name: 'ImageUploader',
  props: {
    method: { type: Function }
  },
  data: () => ({
      serverErrorFlag: false,
      serverErrorMessage: null,
      showValidationAlert: false,
      fileAdded: false,
      sourceImageHref: null,
      targetImageHref: null,
      uploadInProgress: false
  }),
  methods: {
    checkFileAdded(uploadedFiles) {
      let status = (
          uploadedFiles && uploadedFiles.length > 0 && uploadedFiles[0] &&
          uploadedFiles[0].size < 2000000 && uploadedFiles[0].type === "image/jpeg"
      )
      this.fileAdded = status;
      this.showValidationAlert = !status;
    },
    uploadFile() {
      console.log('Running API');
      let formData = new FormData();
      let imageFiles = document.getElementById('file');
      let ctx = this;
      formData.append("file", imageFiles.files[0]);
      // http://localhost:9000/api/anime/resize
      ctx.uploadInProgress = true;
      post('/api/anime/job', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      }).then(function(response){
        ctx.serverErrorMessage = null;
        ctx.serverErrorFlag = false;
        let payload = response['data'];
        let jobId = payload['job_id'];
        let pollCount = 0;
        let failureCount = 0;
        let maxFailureCount = 3;
        let maxPollRequests = 7;
        let pollingTimeout = 7000;
        console.log('Job ID', jobId);
        let continuePolling = true;
        let pollingRequest = setInterval(function () {
          console.log('Polling status');
          if (continuePolling) {
            get(`/api/anime/status/${jobId}`).then(function(response) {
              let payload = response['data'];
              if (payload['status'] === 'success') {
                clearInterval(pollingRequest);
                continuePolling = false;
                ctx.uploadInProgress = false;
                ctx.$emit('send-image-hrefs', {
                  'sourceImageHref': payload['payload']['source'],
                  'targetImageHref': payload['payload']['target'],
                });
              }
              pollCount += 1;
              if(pollCount >= maxPollRequests) {
                continuePolling = false;
                clearInterval(pollingRequest);
                ctx.uploadInProgress = false;
                ctx.serverErrorMessage = 'Server took too long to process the request.';
                ctx.serverErrorFlag = true;
              }
            }).catch(function(e) {
              failureCount += 1
              if(failureCount >= maxFailureCount) {
                ctx.uploadInProgress = false;
                clearInterval(pollingRequest);
                continuePolling = false;
                let serverResponseMessage = e.response.data['detail'];
                serverResponseMessage = (
                  typeof serverResponseMessage !== "undefined") ? serverResponseMessage : 'No response';
                  ctx.serverErrorMessage = `${e.message}: ${serverResponseMessage}`;
                  ctx.serverErrorFlag = true;
                }
            })
          }
        }, pollingTimeout);
      }).catch(function(e){
          console.log('FAILURE!!');
          ctx.uploadInProgress = false;
          let serverResponseMessage = e.response.data['detail'];
          serverResponseMessage = (
              typeof serverResponseMessage !== "undefined") ? serverResponseMessage : 'No response';
          ctx.serverErrorMessage = `${e.message}: ${serverResponseMessage}`;
          ctx.serverErrorFlag = true;
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-title {
  font-variant: small-caps;
}

.image-uploader {
  padding-left: 3%;
  padding-right: 5%;
}

#uploaderCard {
  opacity: 0.85;
  padding: 16px 24px 32px;
}

.upload-button {
  text-align: center;
  margin-top: 16px;
}
</style>
